<script>
  import Modal from '@components/general/modal.svelte'
  import Form from '@components/forms'
  import Button from '@components/buttons/button.svelte'
  import { useForm } from '@inertiajs/svelte'
  import { CirclePlus, Save } from 'lucide-svelte'

  let { user = null, open = $bindable(false), onClose } = $props()

  let isUpdate = $derived(!!user?.id)
  let title = $derived(isUpdate ? `Edit ${user.name}` : "Create admin user")

  const roleOptions = [
    { label: "Admin", value: "admin" },
    { label: "Superadmin", value: "superadmin" },
  ]

  const form = $derived(useForm({
    name: user?.name || '',
    email_address: user?.email_address || '',
    role: user?.role || 'admin',
  }))

  function handleSubmit(e) {
    e.preventDefault()
    if (isUpdate) {
      $form.transform((data) => ({ user: { role: data.role } }))
      $form.put(`/admin/users/${user.id}`, { onSuccess: () => open = false })
    } else {
      $form.transform((data) => ({ user: data }))
      $form.post('/admin/users', { onSuccess: () => { open = false; $form.reset() } })
    }
  }

  function handleClose() {
    onClose?.()
    $form.reset()
    $form.clearErrors()
  }
</script>

<Modal bind:open {title} onClose={handleClose}>

  <Form.Element {form} id="admin-user-form" onsubmit={handleSubmit}>
    <Form.Items>
      {#if !isUpdate}
        <Form.Item name="name" label="Name" bind:value={$form.name} hint="The admin user's full name" cols={12} required />
        <Form.Item name="email_address" label="Email address" type="email" bind:value={$form.email_address} hint="A welcome email will be sent to this address" cols={12} required />
      {/if}
      <Form.Item name="role" label="Role" type="select" bind:value={$form.role} options={roleOptions} labelKey="label" valueKey="value" hint="Superadmins can manage other admin accounts" cols={12} required />
    </Form.Items>
  </Form.Element>

  {#snippet footer()}
    <Button type="submit" form="admin-user-form" variant="submit" loading={$form.processing}
      text={isUpdate ? "Update role" : "Create admin"}
      Icon={isUpdate ? Save : CirclePlus} />
  {/snippet}

</Modal>
